import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getAnalyticsIds, isAnalyticsEnabled } from './siteConfig';

/**
 * Google Analytics 4 и Яндекс.Метрика — только production и при заданных ID в .env.
 * Отслеживает переходы между страницами в SPA (React Router).
 */
export function AnalyticsScripts() {
    const { pathname } = useLocation();
    const enabled = isAnalyticsEnabled();
    const { ga4, yandexMetrika } = enabled ? getAnalyticsIds() : {};

    // Отправляем page_view при каждом переходе между страницами
    useEffect(() => {
        if (!enabled) return;

        if (ga4 && window.gtag) {
            window.gtag('event', 'page_view', { page_path: pathname });
        }

        if (yandexMetrika && window.ym) {
            window.ym(Number(yandexMetrika), 'hit', window.location.href);
        }
    }, [pathname, enabled, ga4, yandexMetrika]);

    if (!enabled) return null;

    return (
        <Helmet>
            {ga4 ? (
                <>
                    <script
                        async
                        src={`https://www.googletagmanager.com/gtag/js?id=${ga4}`}
                    />
                    <script>{`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${ga4}', { anonymize_ip: true, send_page_view: false });
                    `}</script>
                </>
            ) : null}

            {yandexMetrika ? (
                <script>{`
                    (function(m,e,t,r,i,k,a){
                        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                        m[i].l=1*new Date();
                        for (var j = 0; j < document.scripts.length; j++) {
                            if (document.scripts[j].src === r) { return; }
                        }
                        k=e.createElement(t),a=e.getElementsByTagName(t)[0],
                        k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
                    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
                    ym(${yandexMetrika}, 'init', {
                        webvisor: true,
                        clickmap: true,
                        trackLinks: true,
                        trackHash: true,
                        accurateTrackBounce: true,
                        ecommerce: 'dataLayer',
                        defer: true
                    });
                `}</script>
            ) : null}
        </Helmet>
    );
}
